import React from 'react';

const Navbar = () => {
  return (
    <div className="navbar-wrapper">
      <nav className="navbar">
        <div className="navbar-links">
          <a href="#whois" className="vertical-text-link">$Lindy</a>
          {/* <a href="#pfp-generator-container" className="vertical-text-link">PFP Generator</a> */}
          <a href="https://x.com/i/communities/1982534321153130919" className="vertical-text-link">X</a>
          <a href="#flokinomics" className="vertical-text-link">Lindy Paper</a>
          <a href="https://dexscreener.com/solana/5aW63GU53U9iQR5KgyFQq1bK2FymQhwB2qxWdWGepump"
            target="_blank"
            rel="noopener noreferrer"
            className="vertical-text-link">DEX</a>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
